export default __webpack_public_path__ + "static/media/bublFrontPage2.6d4a2c6f.png";